import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, Observable, throwError } from 'rxjs';
import { finalize } from 'rxjs';
import { AuthenticationService } from '../../../../user-management/auth-management/authentication/services/authentication.service';
import { Token } from '../../../../user-management/auth-management/authentication/models/token.model';
import { NetworkStatusService } from '../../../../../trash/shared/services/network-status/network-status.service';

export const AccessTokenHttpInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<any> => {
  const authService = inject(AuthenticationService);
  const networkStatusService = inject(NetworkStatusService);

  // Check if offline before proceeding
  if (!networkStatusService.isOnline()) {
    // Show offline error and block the request
    networkStatusService.showOfflineRequestError();
    return EMPTY; // Break the flow without making a request or throwing an error
  }

  const excludedRoutes: string[] = ['refresh'];
  const isExcluded = excludedRoutes.some((route) => req.url.includes(route));

  // If the route is excluded, proceed without attaching the token
  if (isExcluded) {
    return next(req);
  }

  // Retrieve the token
  const token: Token | undefined = authService.ensureAuthenticated();

  // Clone the request to add the Authorization header
  const clonedReq = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token.accessToken}`
        }
      })
    : req;

  // Pass the cloned request to the next handler
  return next(clonedReq).pipe(
    finalize(() => {
      // Any additional cleanup logic can go here
    })
  );
};
